import * as Yup from 'yup';

export const validationSchema = () =>
  Yup.object({
    description: Yup.string().required('Required').nullable(),
    businessUnitId: Yup.string().required('Required').nullable(),
  });
